import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

export default class MobileGenieRoutinesRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('billing') declare billingService: Service.Billing;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('navigation') declare navigationService: Service.Navigation;

	override async beforeModel(transition: PublicTransition): Promise<void> {
		await this.aiChatService.ensureAvailable(transition);

		// No upgrade popups in the native app: without AI Routines on the plan, routines just don't open.
		if (!this.billingService.checkIfCan(BillingFeature.AI_ROUTINES)) {
			if (!transition.sequence) {
				this.navigationService.replaceRoute('mobile.genie.chat');
			} else {
				transition.abort();
			}
			return;
		}

		await this.mmBoardsService.requestBoards();
	}

	override resetController(_controller: Controller, isExiting: boolean): void {
		if (isExiting) {
			this.aiChatService.applyUrlRoutine(null);
		}
	}
}
